<template>
  <section class="bg-surface-1 border-b border-white/10">
    <RouterLink
      :to="{ name: 'workbench' }"
      class="group flex flex-col md:flex-row md:items-center gap-4 md:gap-8 px-6 lg:px-16 xl:px-40 py-6 text-white hover:text-white"
    >
      <span class="inline-flex items-center self-start md:self-auto px-3 py-1 rounded bg-primary text-white text-xs uppercase tracking-wide shrink-0">
        {{ t('home.workbenchTeaser.tag') }}
      </span>
      <span class="flex-1 flex flex-col gap-1">
        <span class="font-display font-semibold text-xl md:text-2xl">
          {{ t('home.workbenchTeaser.title') }}
        </span>
        <span class="font-sans text-base text-white/70">
          {{ t('home.workbenchTeaser.body') }}
        </span>
      </span>
      <span class="inline-flex items-center gap-2 font-sans text-[18px] text-accent-soft group-hover:text-primary transition-colors shrink-0">
        {{ t('home.workbenchTeaser.cta') }}
        <VaIcon name="arrow_forward" :size="22" class="transition-transform group-hover:translate-x-1" />
      </span>
    </RouterLink>
  </section>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { VaIcon } from 'vuestic-ui'

const { t } = useI18n()
</script>
